// authUtils.js
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';

export const checkAdminStatus = async (org) => {
  const user = auth.currentUser;
  if (!user) return { isAdmin: false, isSuperAdmin: false };

  try {
    const userDocRef = doc(db, `users-${org}`, user.uid);
    const userDoc = await getDoc(userDocRef);

    if (!userDoc.exists()) return { isAdmin: false, isSuperAdmin: false };

    const userData = userDoc.data();
    console.log("ARE YOU ARE SUPER ADMIN? " + userData.superAdmin);
    return {
      isAdmin: userData.admin === true,
      isSuperAdmin: userData.superAdmin === true,
    };
  } catch (error) {
    console.error('Error checking admin status:', error);
    return { isAdmin: false, isSuperAdmin: false };
  }
};
